import EventEmitter from 'events';

// Khởi tạo một EventEmitter instance để sử dụng làm event bus
const eventBus = new EventEmitter();

// Trả về eventBus để có thể sử dụng ở các module khác
export default eventBus;
